import { TRACKING_PROVIDER } from '@celerofinancas/core-ts';

export const environment = {
  cdnUrl: 'https://finance-develop-caixa-webcomponents.celero.mobi',
  allowedThemeMessageOrigin: 'https://gerenciador.caixa.gov.br',
  // Em develop o webcomponent roda sob finance-develop-caixa-webcomponents.celero.mobi
  // (fora do gerenciador da CAIXA), então o targetOrigin fixo não bate. '*' libera o
  // envio no ambiente de teste; em produção (environment.ts) permanece restrito.
  ddaAuthorizationTargetOrigin: '*',
  tracking: { enable: true, provider: TRACKING_PROVIDER.SEGMENT },
  apiUrl: 'https://finance-develop-celero-api-client.celero.mobi',
  creditLineApi: 'https://invest-creditline-caixa-develop-celero-api-client.celero.mobi',
  staticUrl: 'https://static.caixa.celero.mobi',
  webSocketUrl: 'https://finance-develop-celero-api-websocket.celero.mobi',
  colorTheme: 'light',
  colorPalette: 'caixa',
  featureFlag: {
    environmentID: '4vEDQQxQdgJbg7iiifonMb',
    identity: 'client',
    api: 'https://flagsmith-platform.celero.mobi/api/v1/',
  },
  authenticationConfig: {
    issuer: 'https://auth-develop.celero.mobi/realms/Develop',
    redirectUri: `${window.location.origin}/silent-refresh.html`,
    clientId: 'client',
    scope: 'openid profile email',
  },
  chat: {
    appId: 'r18b58oj',
    enabled: true,
    chatProvider: 'intercom',
  },
  sessionReplay: {
    enabled: true,
    provider: 'AMPLITUDE' as const,
    apiKey: 'f1f7c4bb3681a2ae44259b57e651f6bd',
    sampleRate: 1,
    serverZone: 'US' as const,
    debugMode: true,
    privacyConfig: {
      defaultMaskLevel: 'medium' as const,
      blockSelector: ['[data-pii]', '[data-amp-block]', '.cpf', '.cnpj', '.credit-card'],
      maskSelector: ['[data-amp-mask]'],
      unmaskSelector: ['[data-amp-unmask]'],
    },
  },
};
